//import 'babel-polyfill';
import React from 'react';

import Router from './common/router.jsx';

function App() {
  return <Router />;
}

export default App;